import {
  Component,
  computed,
  HostBinding,
  inject,
  signal,
} from '@angular/core';
import { PAGES } from '@constants/constants';
import { deviceListQuery } from '@graphql/asset-management';
import { LayoutComponent } from '@layout/layout.component';
import { ASSET_MANAGEMENT_SUBTITLE } from '@pages/asset-management/asset-management';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';
import { Apollo } from 'apollo-angular';
import { DeviceListQuery, DeviceListQueryVariables, Status } from 'gql/graphql';
import { Subscription } from 'rxjs';

@Component({
  selector: 'abb-property-services',
  standalone: true,
  template: `
    <page-layout
      [page]="PAGES.PROPERTYSERVICES"
      [title]="'Property Services' | t"
    >
      <span
        subtitle
        [innerHTML]="subtitle().key | t : subtitle().params"
      ></span>
      <!-- <div subtitle>
        <span>{{
          'You have a total of {tot} devices' | t : { tot: devices().length }
        }}</span
        >@if (alarmsAndWarningsCount() > 0) {,<span>
          {{
            '{count} of which requires your '
              | t : { count: alarmsAndWarningsCount() }
          }} </span
        ><a href="#" class="underline text-abb-primary">{{
          'attention' | t
        }}</a>
        }.
      </div> -->
    </page-layout>
  `,
  styles: ``,
  host: {
    class: 'flex flex-row flex-1 min-h-0 overflow-hidden',
  },
  imports: [LayoutComponent, TPipe],
  providers: [
    {
      provide: TRANSLATION_PREFIX,
      useValue: 'property_services',
    },
  ],
})
export class PropertyServicesComponent {
  @HostBinding('attr.id') componentid = 'property-services-component';
  private readonly subscriptions: Subscription[] = [];
  readonly PAGES: PAGES = PAGES;
  devices = signal([]); //TODO: a cosa si riferisce?
  subtitle = inject(ASSET_MANAGEMENT_SUBTITLE);
  alarmsAndWarningsCount = computed(() => {
    return 0; //this.devices().length;
  }); //TODO: idem come sopra

  constructor(readonly apollo: Apollo) {
    this.subscriptions.push(
      apollo
        .watchQuery<DeviceListQuery, DeviceListQueryVariables>({
          query: deviceListQuery,
          variables: {
            includeGateway: true,
          },
        })
        .valueChanges.subscribe({
          next: ({ data }) => {
            this.subtitle.set({
              key: 'You are managing a total of {tot} devices, of which {connected} are «connected», {offline} «offline», {noCommunication} with no communication',
              params: {
                tot: data.deviceList.length,
                connected: data.deviceList.filter((d) => d.status === Status.Ok)
                  .length,
                offline: data.deviceList.filter(
                  (d) => d.status === Status.Warning
                ).length,
                noCommunication: data.deviceList.filter(
                  (d) => d.status === Status.Alarm
                ).length,
              },
            });
          },
          error: (err) => {},
        })
    );
  }

    ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
